import React from 'react';
import { RedirectionButton } from './components/Button';
import { Articles, ItemComponent, ItemComponentProps } from './components/Articles';

interface NewsListProps {
  collection: ItemComponentProps[];
  page: number;
  pages: number;
  total: number;
  size: number;
  promotedNews?: ItemComponentProps;
}

export const NewsListContent: React.FC<NewsListProps> = (props) => (
  <main className="articles">
    <div className="articles__top_unit">
      <h2 className="articles__title">Aktualności</h2>
      <div className="articles__navigation">
        <RedirectionButton
          url="/filary"
          color="#8B235D"
          arrowColor="#FAFAFA"
          text="Filary naszej polityki"
        />
      </div>
    </div>
    {
      props?.promotedNews ? (
        <div className="articles__promoted">
          <ItemComponent {...props.promotedNews} />
        </div>
      ) : null
    }
    <Articles
      url="/aktualnosci"
      items={props.collection}
      page={props.page}
      pages={props.pages}
      total={props.total}
      size={props.size}
    />
  </main>
);
